module.exports = __webpack_public_path__ + "img/camel-keyvisual.02864c0b.png";